'use strict';

var didResolver = require('did-resolver');
var webDidResolver = require('web-did-resolver');
var lib = require('../../lib');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const queryDidDocument = /* @__PURE__ */ __name(async ({ domain, did }) => {
  if (!did && !domain) {
    throw new Error("Missing domain");
  }
  if (!did && domain) {
    let domainHostname = lib.getDomain(domain);
    if (!domainHostname) {
      throw new Error("Invalid domain");
    }
    domainHostname = domainHostname.replace(/\/.well-known\/did.json$/, "");
    domainHostname = domainHostname.replace(/\/did.json$/, "");
    did = `did:web:${domainHostname?.replace(/\//g, ":")}`;
  }
  const resolver = new didResolver.Resolver({
    ...webDidResolver.getResolver()
  });
  const doc = await resolver.resolve(did);
  return {
    wellKnownDid: doc?.didDocument,
    did
  };
}, "queryDidDocument");

exports.queryDidDocument = queryDidDocument;
